import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/AboutPage.css';

const AboutPage: React.FC = () => {
  return (
    <div className="about-container">
      <div className="about-content">
        <h1 className="about-title">我们的故事</h1>
        <div className="about-text">
          <p>
            欢迎来到我们的个人博客平台。这里是一个分享思想、记录生活、交流技术的空间。
          </p>
          <p>
            我们相信每个人都有独特的故事值得被讲述，每个想法都有价值被分享。
            无论是技术探索、生活感悟，还是创作灵感，这里都是你的舞台。
          </p>
          <p>
            让我们一起在这个数字时代，用文字连接彼此，用思想照亮未来。
          </p>
        </div>
        <div className="about-actions">
          <Link to="/" className="back-home-btn">
            返回首页
          </Link>
          <Link to="/login" className="start-writing-btn">
            开始写作
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AboutPage; 